export default (object, allowedKeys) => {
  if (!allowedKeys) return { ...object }

  return allowedKeys.reduce((sanitized, key) => (key in object ? {
    ...sanitized,
    [key]: object[key],
  } : sanitized), {})
}
